import { render, staticRenderFns } from "./StatisticsDetails.vue?vue&type=template&id=a7c2f592&scoped=true&"
import script from "./StatisticsDetails.vue?vue&type=script&lang=js&"
export * from "./StatisticsDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsDetails.vue?vue&type=style&index=0&id=a7c2f592&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c2f592",
  null
  
)

export default component.exports